import { useEffect, useState, useMemo } from 'react';
import { useParams } from 'react-router';
import { useLazyQuery } from '@apollo/client/react';
import { Flex, Select, Table, Typography } from 'antd';
import useAccountQuery from 'hooks/useAccountQuery';
import { CREDIT_PROTECTION_SNAPSHOT } from 'queries/snapshots';
import { getCardDisplayName } from 'utilities/helpers';
import Loading from 'components/Loading/Loading';

const { Text } = Typography;

const Snapshots = () => {
  const { customerId } = useParams();
  const [selectedAccountId, setSelectedAccountId] = useState('');
  const { accounts } = useAccountQuery(customerId);

  //REVIEW: No error handling
  const [getCreditProtectionSnapshot, snapshotQuery] = useLazyQuery(
    CREDIT_PROTECTION_SNAPSHOT,
  );

  // probably use function with try catch so we can handle errors
  const snapshots = useMemo(() => {
    const url = snapshotQuery.data?.creditProtectionSnapshot;
    return url
      ? [
          {
            url,
            name: 'Credit Protection Snapshot',
          },
        ]
      : [];
  }, [snapshotQuery.data]);

  useEffect(() => {
    if (selectedAccountId) {
      getCreditProtectionSnapshot({
        variables: { accountId: selectedAccountId },
      });
    }
  }, [selectedAccountId]);

  const column = [
    {
      title: 'Snapshot File',
      key: 'snapshot',
      render: (_, record) => (
        <Text>
          <a
            data-testid="snapshot"
            target="_blank"
            rel="noreferrer"
            href={record.url}
          >
            {record.name}
          </a>
        </Text>
      ),
    },
  ];

  return (
    <Flex vertical={true}>
      <Select
        name="Account Select"
        getPopupContainer={(trigger) => trigger.parentNode}
        data-testid="account-select"
        placeholder="Select account to view snapshots"
        onSelect={(value) => {
          setSelectedAccountId(value);
        }}
        style={{
          width: 'fit-content',
          marginBottom: 'var(--spacing-lg)',
        }}
      >
        {accounts?.map((account) => {
          return (
            <Select.Option
              data-testid={`account-${account.id}`}
              key={`account-${account.id}`}
              value={account.id}
            >
              {getCardDisplayName(account)}
            </Select.Option>
          );
        })}
      </Select>
      {snapshots?.length > 0 && (
        <Table
          size="small"
          dataSource={snapshots}
          columns={column}
          pagination={false}
          rowKey={(record) => `key-${record.name}`}
          style={{ width: '100%' }}
        />
      )}
      {!snapshots?.length && snapshotQuery.loading && <Loading />}
      {!snapshots?.length && !snapshotQuery.loading && 'No snapshots found...'}
    </Flex>
  );
};

export default Snapshots;
